import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { serviceTxTypeApi } from "./tx-types-apis";

export enum TransactionTypeEnum {
  DEPOSIT = "deposit",
  WITHDRAW = "withdraw",
  TRANSFER = "transfer",
  PURCHASE = "purchase",
  REVERSAL = "reversal",
  DIRECT_DEBIT = "direct_debit",
}

interface TxTypeState {
  serviceTxTypes: ServiceTxType[];
}

const initialState: TxTypeState = {
  serviceTxTypes: [],
};

const txTypeSlice = createSlice({
  name: "txTypeSlice",
  initialState,
  reducers: {
    setServiceTxTypes: (state, action: PayloadAction<ServiceTxType[]>) => {
      state.serviceTxTypes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      serviceTxTypeApi.endpoints.loadServiceTxTypes.matchFulfilled,
      (state, action) => {
        state.serviceTxTypes = action.payload;
      }
    );
    builder.addMatcher(
      serviceTxTypeApi.endpoints.bulkSave.matchFulfilled,
      (state, action) => {
        state.serviceTxTypes = action.payload;
      }
    );
    builder.addMatcher(
      serviceTxTypeApi.endpoints.createServiceTxType.matchFulfilled,
      (state, action) => {
        state.serviceTxTypes.push(action.payload);
      }
    );
    builder.addMatcher(
      serviceTxTypeApi.endpoints.createServiceTxType.matchFulfilled,
      (state, action) => {
        const txIndex = state.serviceTxTypes.findIndex(
          (txType) => (txType.id = action.payload.id)
        );
        state.serviceTxTypes[txIndex] = action.payload;
      }
    );
  },
});

export const serviceTxTypeActions = txTypeSlice.actions;
export default txTypeSlice.reducer;
